import {merge} from "../../../helpers";

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    get: state => {
      return state.list;
    },
  },

  mutations: {
    set(state, recommendations) {
      state.list = recommendations;
    },

    save(state, payload) {
      const recommendation = payload.recommendation;
      const canUpdate = payload.canUpdate || false;

      // if payload.product.external_id is not set - throw an error
      if (
        recommendation.line_item == null ||
        recommendation.line_item.product == null ||
        recommendation.line_item.product.external_id == null
      ) {
        throw new Error('Store mutator "local/recommendations/put" expects "line_item.product.external_id" to be set.');
      }

      const index = state.list.findIndex(item => {
        return item.line_item.product.external_id.toString() === recommendation.line_item.product.external_id.toString();
      });

      // add - if it does not exists yet
      if (index < 0) {
        state.list.push(recommendation);
        return;
      }
      // update or replace
      if (canUpdate) {
        state.list[index] = merge(state.list[index], recommendation);
      } else {
        state.list[index] = recommendation;
      }
    },

    delete(state, recommendation) {
      // if payload.product.external_id is not set - throw an error
      if (
        recommendation.line_item == null ||
        recommendation.line_item.product == null ||
        recommendation.line_item.product.external_id == null
      ) {
        throw new Error('Store mutator "local/recommendations/put" expects "line_item.product.external_id" to be set.');
      }

      const index = state.list.findIndex(item => {
        return item.line_item.product.external_id === recommendation.line_item.product.external_id;
      });

      if (index < 0) {
        // TODO: log warning about non existent recommendation
        return;
      }

      // delete element from array
      state.list.splice(index, 1);
    },
  },

  actions: {
    post({dispatch, commit}, recommendation) {
      commit('save', {
        recommendation,
        canUpdate: false,
      });
      dispatch('local/save', null, {root: true});
    },
    put({dispatch, commit}, recommendation) {
      commit('save', {
        recommendation,
        canUpdate: true,
      });
      dispatch('local/save', null, {root: true});
    },
    delete({dispatch, commit}, recommendation) {
      commit('delete', recommendation);
      dispatch('local/save', null, {root: true});
    },
  },
};
